import { buildCaseloadFigures, buildSampleDigest } from '@innerhive-internal/innerhive-common';
import type { IAgencyInsights } from './useAgencyInsights';

/** What the tab shows under the admin-only demo setting: the invented caseload, and nobody real. */
export const buildDemoInsights = (params: { now: Date; retry: () => Promise<void> }): IAgencyInsights => ({
    ...buildCaseloadFigures(buildSampleDigest(params.now)),
    hasLoaded: true,
    nothingReadable: false,
    isDemo: true,
    unreadableClients: [],
    retry: params.retry
});
